@let currentPopup = popup();
<div class="bg-white flex flex-col overflow-hidden pointer-events-auto select-none will-change-[transform,top,left] transform-gpu backface-hidden"
    [ngClass]="{
      'fixed inset-0 z-screen-overlay-90': currentPopup.isFullscreen,
      'absolute border-0 rounded-[0.5rem] shadow-[0px_0.25rem_1.25rem_0px_var(--p-other-opacity-black-25)]': !currentPopup.isFullscreen
    }"
    [style.z-index]="currentPopup.isFullscreen ? null : currentPopup.zIndex"
    [style.z-index]="currentPopup.isFullscreen ? null : currentPopup.zIndex"
    [style.width.px]="currentPopup.isFullscreen ? null : currentPopup.width"
    [style.height.px]="currentPopup.isFullscreen ? null : currentPopup.height"
    [style.left.px]="currentPopup.isFullscreen ? 0 : currentPopup.x"
    [style.top.px]="currentPopup.isFullscreen ? 0 : currentPopup.y"
    pFocusTrap
    cdkDrag
    [cdkDragBoundary]="popupBoundaryClass"
    [cdkDragFreeDragPosition]="{x: 0, y: 0}"
    (cdkDragEnded)="onDragEnd($event)"
    (mousedown)="service.focus(currentPopup.id)">

  @if (!currentPopup.isFullscreen) {
    <div (mousedown)="onResizeStart($event, ResizeDirection.N)" class="absolute top-0 inset-x-0 h-1.5 cursor-ns-resize z-10 hover:bg-blue-400/20"></div>
  
    <div (mousedown)="onResizeStart($event, ResizeDirection.S)" class="absolute bottom-0 inset-x-0 h-1.5 cursor-ns-resize z-10 hover:bg-blue-400/20"></div>
    
    <div (mousedown)="onResizeStart($event, ResizeDirection.E)" class="absolute right-0 inset-y-0 w-1.5 cursor-ew-resize z-10 hover:bg-blue-400/20"></div>
    
    <div (mousedown)="onResizeStart($event, ResizeDirection.W)" class="absolute left-0 inset-y-0 w-1.5 cursor-ew-resize z-10 hover:bg-blue-400/20"></div>

    <div (mousedown)="onResizeStart($event, ResizeDirection.NW)" class="absolute top-0 left-0 w-3 h-3 cursor-nwse-resize z-10"></div>
    
    <div (mousedown)="onResizeStart($event, ResizeDirection.NE)" class="absolute top-0 right-0 w-3 h-3 cursor-nesw-resize z-10"></div>
    
    <div (mousedown)="onResizeStart($event, ResizeDirection.SW)" class="absolute bottom-0 left-0 w-3 h-3 cursor-nesw-resize z-10"></div>
    
    <div (mousedown)="onResizeStart($event, ResizeDirection.SE)" class="absolute bottom-0 right-0 w-3 h-3 cursor-nwse-resize z-10"></div>
  }
  
  <div class="contents" cdkDragHandle>
    <ng-content select="[floating-popup-header]"></ng-content>
  </div>
  
  <div class="flex-1 overflow-auto bg-white relative z-1">
    <ng-content select="[floating-popup-body]"></ng-content>
  </div>
</div>